/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

import { rhythm } from "../utils/typography"

require(`./bio.css`)

function BioFull() {
  return (
    <StaticQuery
      query={bioFullQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div
            style={{
              marginBottom: rhythm(2.5),
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap-reverse", marginTop: rhythm(1.0) }}>

              <div class='bio' style={{ flex: "70%" }}>
                <p>My name is Panagiotis (Παναγιώτης, IPA: [panaˈʝotis]) and I’m a DPhil student at Oxford University studying in the area of Autonomous Intelligent Machines and Systems, under the supervision of Dr. Yarin Gal (<a href="https://oatml.cs.ox.ac.uk/">OATML</a>). I am interested in applied and theoretical cybernetics, autonomous and intelligent natural and artificial systems, generative and algorithmic design.<br /><br />In past life, I worked as ML engineer for companies like <a href="https://www.microsoft.com">Microsoft</a>, <a href="https://autodeskresearch.com/projects/dreamcatcher">Autodesk</a>, <a href="https://brave.com">Brave</a> and co-run my own startup <a href="https://www.filisia.com">Filisia</a>, a company specialized in special-education technology.</p>

                {/* <h4>Contact</h4>
                <p>
                  Wolfson Building,<br/>Parks Road, Oxford OX1 3QD,<br/>United Kingdom<br/>
                  <code>ptigas [at] robots.ox.ac.uk</code>
                </p>
                <div style={{ marginTop: rhythm(0.5) }}>
                  <a href="https://twitter.com/ptigas">Twitter</a>  /  <a href="https://www.dropbox.com/s/z9hsa88ec1p9ec6/ptigas_cv.pdf">CV</a>  /  <a href="https://github.com/ptigas">GitHub</a>
                </div> */}
              </div>

              <div class='bio_avatar' style={{ flex: "30%", textAlign: "center", marginTop: '3px' }}>
                <Image
                  fixed={data.avatar.childImageSharp.fixed}
                  alt={author}
                  style={{
                    minWidth: 200,
                    minHeight: 200,
                    borderRadius: `100%`,
                  }}
                  imgStyle={{
                    borderRadius: `50%`,
                  }}
                />
              </div>

            </div>

            <div style={{ marginTop: rhythm(0.5) }}>
              <a href="https://twitter.com/ptigas">twitter</a>  /  <a href="https://github.com/ptigas">github</a>
            </div>

            <div style={{ marginTop: rhythm(2) }}></div>
            <h3 id="work-experience">Research Interests</h3>

            <p>My research focuses on designing complex intelligent systems covering learning and planning under uncertainty. My work is inspired by cognitive science (e.g. theory of mind), philosophy (<a href="http://cid.nada.kth.se/en/HeideggerianAI.pdf">Heidegger</a>, <a href="https://plato.stanford.edu/entries/lacan/#RegThe">Lacan</a>, <a href="https://plato.stanford.edu/entries/bayes-theorem/">Bayes</a>, <a href="https://plato.stanford.edu/entries/wittgenstein/#MeanUse">Wittgenstein</a>, <a href="https://plato.stanford.edu/entries/david-lewis/#2">David Lewis</a>), biology (Maturana's theory of <a href="https://monoskop.org/images/3/35/Maturana_Humberto_Varela_Francisco_Autopoiesis_and_Congition_The_Realization_of_the_Living.pdf">Living Systems</a>, emergent complexity and <a href="https://royalsocietypublishing.org/doi/10.1098/rstb.2019.0040">liquid brain systems</a>) but also information theory and statistical mechanics (<a href="https://www.fil.ion.ucl.ac.uk/~karl/The%20free-energy%20principle%20-%20a%20rough%20guide%20to%20the%20brain.pdf">free energy</a> principle in control).</p>

            <p>My research finds application on domains like autonomous driving, a multi-agent problem where uncertainty and faulty decision making can be fatal, or architecture, where planning and control is applied in multiple scales (from ambient intelligence to urban planning).</p>

            < div style={{ marginTop: rhythm(1) }
            }></div>

            <h3 id="work-experience">Work Experience</h3>

            <ul>
              <li><span class="date">summer 2021</span> <span class="what">PhD Internship - <a href="https://www.microsoft.com/en-us/research/group/deep-reinforcement-learning/">Microsoft Research, Game Intelligence Group, Cambridge</a></span></li>
              <li><span class="date">summer 2020</span> <span class="what">Machine Learning Researcher - <a href="https://frontierdevelopmentlab.org/">NASA Frontier Development Lab (Hosted by SETI)</a></span></li>
              <li><span class="date">2018 - 2019</span> <span class="what">Machine Learning Researcher (Privacy-Preserving ML) - <a href="https://brave.com/">Brave Research</a></span></li>
              <li><span class="date">2017 - 2018</span> <span class="what">Senior Software / ML Engineer - Autodesk Research (<a href="https://autodeskresearch.com/projects/dreamcatcher">Project Dreamcatcher</a>)</span></li>
              <li><span class="date">2016 - 2017</span> <span class="what">CTO - <a href="http://www.filisia.com/">Filisia Interfaces</a></span></li>
              <li><span class="date">2012 - 2015</span> <span class="what">Software Development Engineer II - <a href="https://www.microsoft.com/">Microsoft</a></span></li>
              <li><span class="date">2011 - 2012</span> <span class="what">Software Developer - Buyometrics</span></li>
            </ul>

            <h3 id="teaching--workshops">Teaching / Workshops</h3>

            <ul>
              <li><span class="date">Feb 2018</span> <span class="what"><a href="https://www.ucl.ac.uk/bartlett/">UCL Bartlett school of Architecture</a> - Machine Learning / AI Tutor</span></li>
              <li><span class="date">Jan 2017</span> <span class="what"><a href="https://www.herts.ac.uk/">University of Hertfordshire<a></a> - Introduction to Arduino: Build a self-driving car</a></span></li>
            </ul>


            <h3 id="work-experience">Reviewer / Service</h3>

            <p>ICML (2020, 2021), ICLR (2021), NeurIPS (2021)</p>

            <h3 id="exhibitions--talks--work-appeared">Exhibitions / Talks / Work Appeared</h3>

            <ul>
              <li><span class="date">Nov 2020</span> <span class="what">Qualcomm, Amsterdam - Research Talk "Can Autonomous Vehicles Identify, Recover From, and Adapt to Distribution Shifts?" </span></li>
              <li><span class="date">Oct 2020</span> <span class="what">ETH, Zurich - AIA Symposium, Research talk "Towards an Autonomous Architecture"</span></li>
              <li><span class="date">Jan 2018</span> <span class="what">Research Values - panel talk, Transmediale, Berlin</span></li>

              <li><span class="date">Jan 2018</span> <span class="what">Research Values - panel talk, Transmediale, Berlin</span></li>
              <li><span class="date">Jan 2016</span> <span class="what">Filisia Interfaces, Bett Show, London</span></li>
              <li><span class="date">Oct 2015</span> <span class="what">Down To Earth, 66th International Astronautical Congress, Jerusalem</span></li>
              <li><span class="date">Aug 2015</span> <span class="what">Voice Booth, Institute of Contemporary Art, Miami</span></li>
              <li><span class="date">Mar 2015</span> <span class="what">Parallel Chance, FutureFest, London</span></li>
              <li><span class="date">Mar 2015</span> <span class="what">Parallel Chance, Tomorrows Transaction forum , London</span></li>
              <li><span class="date">Sep 2014</span> <span class="what"><a href="http://caveofsounds.com" target="_blank">Cave of Sounds</a>, 90db Festival, Rome</span></li>
              <li><span class="date">Mar 2014</span> <span class="what">Voice Booth, SXSW (South by Southwest) 2014 Interactive Awards, Austin, Texas</span></li>
              <li><span class="date">Apr 2014</span> <span class="what">Down To Earth, International Space Apps Challenge led by NASA, Dana Center, London.</span></li>
              <li><span class="date">Nov 2013</span> <span class="what"><a href="http://caveofsounds.com" target="_blank">Cave of Sounds</a>, Watermans’ Digital Art &amp; Performance Weekender, London</span></li>
              <li><span class="date">Sep 2013</span> <span class="what"><a href="http://caveofsounds.com" target="_blank">Cave of Sounds</a>, V&amp;A, Digital Design Weekend, part of London Design Festival</span></li>
              <li><span class="date">Aug 2013</span> <span class="what"><a href="http://caveofsounds.com" target="_blank">Cave of Sounds</a>, Hack the Barbican, London</span></li>
              <li><span class="date">Apr 2013</span> <span class="what">International Space Apps Challenge led by NASA, Google Campus, London</span></li>
            </ul>

          </div >
        )
      }}
    />
  )
}

const bioFullQuery = graphql`
  query BioFullQuery {
    avatar: file(absolutePath: { regex: "/avatar.png/" }) {
      childImageSharp {
        fixed(width: 200, height: 200) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default BioFull
